import React from 'react'
import {SECTIONS} from '../../../../../../Utils/Constant/FlowConstants'

import {DraggableNode} from '../../SidebarLeft/SidebarLeft'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'

interface NodeSelectProps {
  omittedTypes?: string[]
  onSelect: (type: string) => void
}

const NodeSelect: React.FC<NodeSelectProps> = ({omittedTypes = [], onSelect}) => {
  const {t} = useI18n()
  return (
    <div className='p-3'>
      {SECTIONS.map(({title, items, moreInfo}) => (
        <React.Fragment key={title}>
          <div className='d-flex flex-column gap-1 p-1'>
            <h5 className='d-flex align-items-center gap-1'>
              {t(title)}
              <i
                className='bi bi-info-circle ms-1'
                style={{fontSize: '1rem', color: '#A0A0A0', cursor: 'pointer'}}
                title={t(moreInfo || '')}
                tabIndex={0}
                aria-label={t(moreInfo || '')}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                }}
              />
            </h5>
            {items
              .filter((item) => !omittedTypes.includes(item.type.toLowerCase()))
              .map((item) => (
                <DraggableNode
                  key={item.type}
                  item={item}
                  onDragStart={() => {}}
                  isVisible={item.isVisible}
                  onSelect={(type) => {
                    onSelect(type.toLowerCase())
                  }}
                />
              ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default NodeSelect
